import { FC } from 'react';
import styled from 'styled-components';
import delete_icon from '../../../../assets/delete_icon.svg';
import home_icon from '../../../../assets/home_icon.svg';
import bed_icon from '../../../../assets/bed_icon.svg';
import bath_icon from '../../../../assets/bath_icon.svg';
import arrow_right_icon from '../../../../assets/arrow_right_icon.svg';
import { IProperty } from '../../../../store/realEstate/interface';
import { useNavigate } from 'react-router-dom';
import { currencyFormatter } from '../../../../utils/currencyConverter';
import { Carousel } from '../../../../component/carousel';
import { pxToRem } from '../../../../utils/pxToRem';

type IPropertyListCard = {
  handleDelete: () => void;
  propertyItem: IProperty;
};

export const PropertyListCard: FC<IPropertyListCard> = ({
  propertyItem,
  handleDelete
}) => {
  const navigate = useNavigate();
  const handleView = () => {
    navigate(`/real-estate/view/${propertyItem.title}/${propertyItem._id}`, {
      state: { propertyId: propertyItem._id }
    });
  };

  return (
    <Card>
      <PropertyImage>
        <Carousel images={propertyItem.file} />
      </PropertyImage>
      <DeleteBtn onClick={handleDelete}>
        <Icon src={delete_icon} />
      </DeleteBtn>
      <PropertyDetails>
        <PropertyHeader>
          <PropertyName>{propertyItem.title}</PropertyName>
          <PropertyPrice>
            N{currencyFormatter(propertyItem.price)}
          </PropertyPrice>
        </PropertyHeader>
        <IconRow>
          <IconContainer>
            <Icon src={bed_icon} />
            <IconTitle>{propertyItem.noOfRooms} Rooms</IconTitle>
          </IconContainer>
          <IconContainer>
            <Icon src={bath_icon} />
            <IconTitle>{propertyItem.noOfBath} Baths</IconTitle>
          </IconContainer>
          <IconContainer>
            <Icon src={home_icon} />
            <IconTitle>{`${
              propertyItem?.type === 'land'
                ? `${propertyItem.landSize.value} ${propertyItem.landSize.unit}`
                : `${propertyItem?.roomSize} Sqm`
            }`}</IconTitle>
          </IconContainer>
        </IconRow>
        <PropertyDescription>{propertyItem.description}</PropertyDescription>
        <ViewBtn onClick={handleView}>
          <p>View</p>
          <Icon src={arrow_right_icon} />
        </ViewBtn>
      </PropertyDetails>
    </Card>
  );
};

const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  position: relative;
  padding: 8px 8px 35px 8px;
  width: calc(30.33% - 16px);
  max-height: 498px;
  margin: 0px 10px;
  margin-bottom: 48px;
  @media (max-width: 1000px) {
    width: calc(45% - 16px);
    margin: 0px 15px;
    margin-bottom: 48px;
  }
  @media (max-width: 730px) {
    width: 100%;
    margin: 0;
    margin-bottom: 48px;
  }
`;

const PropertyImage = styled.div`
  border-radius: 16px;
  width: 100%;
  max-height: 200px;
  object-fit: cover;
  background-color: #c4c4c4;
`;
const DeleteBtn = styled.button`
  position: absolute;
  right: 24px;
  top: 16px;
  background-color: transparent;
  outline: none;
  border: none;
  padding: 0;
  & :hover {
    opacity: 0.6;
  }
`;
const Icon = styled.img`
  max-height: 48px;
  max-width: 48px;
`;

const PropertyDetails = styled.div`
  padding: 23px 16px 0px 16px;
`;

const PropertyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PropertyPrice = styled.p`
  font-weight: 500;
  font-size: ${pxToRem(16)};
  line-height: 140%;
  color: #a1a1a1;
  margin-bottom: 16px;
`;

const PropertyName = styled.p`
  font-size: ${pxToRem(16)};
  font-style: normal;
  font-weight: 500;
  line-height: ${pxToRem(22)};
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 16px;
  text-transform: capitalize;
`;
const IconRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;
const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const IconTitle = styled.p`
  font-size: ${pxToRem(12)};
  font-style: normal;
  text-transform: capitalize;
  font-weight: 400;
  line-height: ${pxToRem(14)};
  letter-spacing: 0px;
  text-align: center;
  margin-top: 8px;
`;
const PropertyDescription = styled(PropertyName)`
  font-size: ${pxToRem(14)};
  font-weight: 400;
  overflow: hidden;
  height: 66px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

const ViewBtn = styled.button`
  font-style: normal;
  font-weight: 500;
  font-size: ${pxToRem(12)};
  line-height: 150%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  padding: 7px 12px;
  outline: none;
  border: none;
  padding: 0;
  color: ${({ theme }) => theme.colors.sojiOrange};
  & :hover {
    opacity: 0.6;
  }
`;
